import { Resource } from './../resource';
export class Country extends Resource {
    name: string | null | undefined;
}